import { render, staticRenderFns } from "./VirtualScrollList.vue?vue&type=template&id=4935afeb&scoped=true&"
import script from "./VirtualScrollList.vue?vue&type=script&lang=js&"
export * from "./VirtualScrollList.vue?vue&type=script&lang=js&"
import style0 from "./VirtualScrollList.vue?vue&type=style&index=0&id=4935afeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4935afeb",
  null
  
)

export default component.exports